import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function DatePickerInput({ selectedDate, setSelectedDate }) {
  const today = new Date();

  return (
    <DatePicker
      selected={selectedDate}
      onChange={(date) => setSelectedDate(date)}
      placeholderText="Please select date"
      dateFormat="yyyy-MM-dd" // ← фиксированный ISO формат
      className="w-full border border-black p-3 rounded"
      calendarClassName="rounded shadow-lg"
      minDate={today}
      highlightDates={[today]}
    />
  );
}
